<template>
  <div>
    <div class="title">
      <div class="one"><i class="el-icon-share"></i>热门目的地</div>
      <h2>探索热门城市</h2>
      <span>精选全国最受欢迎的旅行目的地</span>
    </div>
    <ul class="popular-cities">
      <li v-for="(item,index) in PopularCitiesList" :key="index" @click="viewDetails(item.date)">
        <img :src="item.pic">
        <div class="bg-gradient-to-t"></div>
        <div class="info">
          <div class="ont">{{item.ont}}</div>
          <div class="name">{{item.name}}</div>
          <div class="text">{{item.text}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      PopularCitiesList:[
        {
          name:'杭州',
          pic:'/images/public/rmcs_1.jpg',
          text:'西湖胜地，江南秀美杭城',
          ont:'热门',
          date:{
            cityName:'杭州',
            cityId:'940',
          }
        },
        {
          name:'南京',
          pic:'/images/public/rmcs_2.jpg',
          text:'六朝古都，金陵盛境',
          ont:'热门',
          date:{
            cityName:'南京',
            cityId:'820',
          }
        },
        {
          name:'上海',
          pic:'/images/public/rmcs_3.jpg ',
          text:'东方明珠，江海都会',
          ont:'热门',
          date:{
            cityName:'上海',
            cityId:'3294',
          }
        },
        // {
        //   name:'成都',
        //   pic:'/images/public/hotel1.jpg',
        //   text:'天府之国·休闲慢城',
        // },
        // {
        //   name:'三亚',
        //   pic:'/images/public/hotel1.jpg',
        //   text:'阳光海岸·度假天堂',
        // }
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    viewDetails(item){
      this.$router.push({
        path:'/index_hotel',
        query:{
         ...item
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
  .title{
    text-align: left;
  }
  .title h2{
    font-size: 22px;
  }
  .title span{
    color: #999;
  }
  .title .one{
    color: var(--smtc-color-primary);
    display: flex;
    i{
      font-size: 20px;
    }
  }
  .popular-cities{
    display: flex;
    margin-top: 20px;
    li{
      width: 22.6%;
      height: 200px;
      overflow: hidden;
      margin-right: 3.2%;
      position: relative;
      border-radius: 16px;
      cursor: pointer;
      img{
        width: 100%;
        height: 200px;
        transition: transform 0.25s ease;
      }
    }
    li:hover img{
      transform: scale(1.1);
    }
    li:nth-child(1){
      width: 48.4%;
    }
    li:last-child{
      margin-right: 0;
    }
  }
  .bg-gradient-to-t {
    width: 100%;
    position: absolute;
    top: 0;
    height: 200px;
    left: 0;
    background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.4));
  }
  .popular-cities .info{
    position: absolute;
    bottom:20px;
    left: 20px  ;
    width: 94%;
    color: #fff;
    text-align: left;
    .ont{
      font-size: 12px;
      background-color: var(--smtc-color-primary);
      color: #fff;
      width: 50px;
      text-align: center;
      padding: 4px 0;
      border-radius: 25px;
      margin-bottom: 4px;
    }
    .name{
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .text{
      color: color-mix(in oklab, #fff 80%, transparent);;
    }
  }
</style>
